import {Button} from '@mui/material'
import { makeStyles } from "@mui/styles";
import React from 'react'
import PropTypes from 'prop-types';

const CustomOutlinedButton = (props) => {
    const useStyles = makeStyles((theme) => ({
        
        title: {
            "&:disabled": {
                opacity:0.5
            },
            display:'inline-flex !important',
            justifyContent:'center !important',
            alignItems:'center !important',
            flexShrink:0,
            height:'40px !important',
            minWidth:'150px !important',
            color: "#00A4FF !important",
            borderRadius:'8px !important',
            border:'1px solid #00A4FF !important',
            fontFamily:'inter !important',
            fontSize:'14px !important',
            fontStyle:'normal !important',
            fontWeight:'500 !important',
            lineHeight:'20px !important',
            marginLeft:'10px !important',
            marginRight:'0px !important',
            "@media (max-width: 1440px)": {
                height:'40px !important',
                padding:'4px 16px !important',
                fontSize:'12px !important',
              },
        },
    }))
    const { title, prefixIcon, suffixIcon} = props
    const classes = useStyles()
    return (
        <>
            <Button className={classes.title} onClick={props.onBtnClick} disabled={props.disabled}>
              <span style={{verticalAlign:'middle',alignItems:'center',marginRight:'5px',paddingTop:'6px',fontFamily:'inter'}}>{prefixIcon}</span>
                {title}
              <span style={{verticalAlign:'middle',alignItems:'center',marginLeft:'5px',paddingTop:'4px',fontFamily:'inter'}}>{suffixIcon}</span>
            </Button>
        </>
    )
}

CustomOutlinedButton.propTypes = {
    title: PropTypes.any,
    prefixIcon:PropTypes.any,
    suffixIcon:PropTypes.any
};
export default CustomOutlinedButton

